module.exports = __webpack_public_path__ + "img/blog8.6ef46bae.png";